import React, { Suspense, useRef, useState, useEffect, useMemo } from 'react'
import './App.css';
import * as THREE from 'three';
import { Stats, Html, Center, OrbitControls, FirstPersonControls } from '@react-three/drei';
import { Canvas, extend, useThree, useFrame } from '@react-three/fiber'
import { useLoader } from '@react-three/fiber'
import { useTexture } from '@react-three/drei';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass'
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass'
import { Vector3 } from 'three';
import LSystem  from './LSystem';
import { Particles, Planets, Stairs, Buildings, Road } from './ParticleSystems';
import {WasdControls, LookControls} from './WasdControls'

extend({ EffectComposer, RenderPass, UnrealBloomPass });


function Effect({ down }) {
  const composer = useRef()
  const { scene, gl, size, camera } = useThree()
  const aspect = useMemo(() => new THREE.Vector2(size.width, size.height), [size])
  useEffect(() => void composer.current?.setSize(size.width, size.height), [size])
  useFrame(() => composer.current?.render(), 1)
  return (
    <>
    <effectComposer ref={composer} args={[gl]}>
      <renderPass attachArray="passes" scene={scene} camera={camera} />
      <unrealBloomPass attachArray="passes" args={[aspect, 1, 0.5, 0]} />
    </effectComposer>
    </>
  )
}



const params = new URLSearchParams(window.location.search);
const viewer = params.get('viewer');
let viewerIsOwner = false;
let objkt = parseInt(params.get("objkt"), 10);

const query = `
query Objkt($id: bigint!) {
  hic_et_nunc_token_by_pk(id: $id) {
    token_holders(where: {quantity: {_gt: "0"}}, order_by: {id: asc}) {
      quantity
      holder {
        address
        name
      }
    }
  }
}
`;


async function fetchGraphQL(operationsDoc, operationName, variables) {
  const result = await fetch(
    "https://api.hicdex.com/v1/graphql",
    {
      method: "POST",
      body: JSON.stringify({
        query: operationsDoc,
        variables: variables,
        operationName: operationName
      })
    }
  );

  return await result.json();
}

async function doFetch() {
  if(!objkt) return;
  const { errors, data } = await fetchGraphQL(query, "Objkt", {"id":objkt});
  if (errors) {
    console.error(errors);
  }
  else 
  {
    const result = data.hic_et_nunc_token_by_pk;
    console.log({ result });
    return result;
  }
}

function checkViewerIsOwner(data) {
  if(!data || !data.token_holders) return;
  if (data.token_holders.some((e) => e.holder.address === viewer)) {
    console.log(`viewer IS owner`);
    viewerIsOwner = true;
  } else {
    console.log(`viewer is NOT owner`);
  }
  //console.log({ OBJKT: data });
}

function changeData(data) {
  console.log(data);
  if(!data || !data.token_holders) return;

  let curData = data.token_holders.map((holder) => { 
    return {name:    holder.holder.name ? holder.holder.name : 
                                holder.holder.address.substr(0,4) + "..." + holder.holder.address.substr(-4), 
            address: holder.holder.address};
  });
  let swapData = data.swaps?.map((holder) => { 
    return {name:    holder.creator.name ? holder.creator.name : 
                                holder.creator.address.substr(0,4) + "..." + holder.creator.address.substr(-4), 
            address: holder.creator.address};
  });
  
  console.log(swapData)
  return curData.concat(swapData);
}

function rotationAngle(random) {
  return Math.PI / 2;
}

// let data = doFetch();
let first = true; 
let curve;
function Path() {
  const ref = useRef();
  const dummy = new THREE.Object3D();
  const { camera } = useThree();
  const texture =  useLoader(THREE.TextureLoader, "line.png");
  texture.wrapT = THREE.RepeatWrapping;
  texture.wrapS = THREE.RepeatWrapping;
  texture.repeat.set(2000,1)
  

  useEffect(() => {
    if(!first) return;
    first = false;

    camera.position.set(50,0,0)

    for( var i = 0; i < ref.current.children.length; i++) { 
      let obj = ref.current.children[i];
      ref.current.remove(obj);
    }
    console.log(ref.current);

    const system = new LSystem();
    system.nextStep(10);

    const path = [];

    let box = new THREE.Mesh(new THREE.BoxGeometry(1,1,1), new THREE.MeshBasicMaterial());
    let bridge = new THREE.Mesh(new THREE.BoxGeometry(0.1,1,5), new THREE.MeshBasicMaterial());
    dummy.lookAt(new Vector3(0,0,1));
    for(let i=0; i < system.string.length; i++) {
      if(system.string[i] === 'F') {
        let dir = new THREE.Vector3();
        dummy.getWorldDirection(dir);

        dummy.position.add(dir.multiplyScalar(5));
        dummy.updateMatrix();
        path.push(dummy.position.clone().addScalar(Math.random()));
        
        // bridge.position.copy(dummy.position);
        // bridge.rotation.copy(dummy.rotation);
        // bridge.rotation.z = 0;
        // ref.current.add(bridge.clone());
      }
      else if(system.string[i] === '/') {
        dummy.rotateY(rotationAngle());
      }
      else if(system.string[i] === '\\') {
        dummy.rotateY(-rotationAngle());
      }
      else if(system.string[i] === '^') {
        dummy.rotateX(rotationAngle());
      }
      else if(system.string[i] === '&') {
        dummy.rotateX(-rotationAngle());
      }
      else if(system.string[i] === 'B') {
        box.position.copy(dummy.position);
        // ref.current.add(box.clone());

        
        // bridge.position.copy(dummy.position);
        // bridge.rotation.copy(dummy.rotation);
        // bridge.rotation.z = 0;
        // ref.current.add(bridge.clone());
      }

    }

    curve = new THREE.CatmullRomCurve3(path);
    const geometry = new THREE.TubeGeometry( curve, 2000, 1, 8, false );
    const material = new THREE.MeshBasicMaterial( {map: texture, transparent: true} );
    const mesh = new THREE.Mesh( geometry, material );
    ref.current.add(mesh);
  });

  useFrame(({clock}) => {
    texture.offset.set(clock.elapsedTime, 0);
    if(curve){
      // camera.position.copy(curve.getPointAt((clock.elapsedTime) / 1000 ));
      // camera.lookAt(curve.getPointAt((clock.elapsedTime + 2) / 1000 ));
      
      // let dir = new THREE.Vector3();
      // camera.getWorldDirection(dir);
      // camera.position.add(new THREE.Vector3(2,3,2))
    }
  })

  return (
  <group ref={ref}>

  </group>);
}

function addPole(obj, pos, texture) {

  let box = new THREE.Mesh(new THREE.BoxGeometry(30,5,30), new THREE.MeshPhysicalMaterial( { color: 0x222222, metalness: 0.4, roughness: 0.4 } ));
  let cylinder = new THREE.Mesh(new THREE.CylinderGeometry( 5, 5, 200, 32 ), new THREE.MeshStandardMaterial( { map: texture, color: 'green' } ));
  box.position.copy(pos);
  cylinder.position.copy(pos);
  cylinder.position.y -= 100;

  for(let j = 0; j < 5; j++)
  {
    let path = [];
    for(let i=0; i < 10; i++) {
      path.push(new THREE.Vector3(Math.random() * 20 - 10, -i * 20, Math.random() * 20 - 10).add(pos));
    }

    curve = new THREE.CatmullRomCurve3(path);
    const geometry = new THREE.TubeGeometry( curve, 100, 1, 8, false );
    const material = new THREE.MeshBasicMaterial( { map: texture, color: 'green' } );
    const mesh = new THREE.Mesh( geometry, material );
    obj.add(mesh);
  }
  
  obj.add(box.clone());
  obj.add(cylinder.clone());
}

function Stage() {
  const ref = useRef();
  const background = useRef();

  const texture2 = useLoader(THREE.TextureLoader, "noise2.png");
  const texture = useLoader(THREE.TextureLoader, "noise.png");
  texture.wrapS = THREE.RepeatWrapping;
  texture.wrapT = THREE.RepeatWrapping;
  texture.repeat.set(100,1);
  
  useEffect(() => {

    let path = [];
    let tita = Math.random() * 20 - 10;
    let phi = Math.random() * 20 - 10;
    for(let i=0; i < 100; i++) {
      tita += Math.random();
      phi += Math.random();
      let radius = 200;
      path.push(new THREE.Vector3(Math.sin(tita) * Math.sin(phi) * radius, Math.cos(tita) * Math.sin(phi) * radius, Math.cos(phi) * radius));
    }

    curve = new THREE.CatmullRomCurve3(path);
    const geometry = new THREE.TubeGeometry( curve, 200, 10, 16, false );
    const material = new THREE.MeshBasicMaterial( { map: texture2, color: 0x051005, fog:false, transparent: true, opacity: 0.15 } );
    const mesh = new THREE.Mesh( geometry, material );
    background.current.add(mesh);

    // for(let i=0; i < 10; i++)
    addPole(ref.current, new THREE.Vector3(0,0,0), texture);
  });

  useFrame(({clock, camera}) => {
    texture.offset.set(clock.elapsedTime, 0);
    background.current.position.copy(camera.position)
    // camera.rotation.set(Math.PI / 4, 0, 0);
  })

  return (
    <group ref={ref}>
      <mesh ref={background}></mesh>
    </group>);
}

function FollowCam({ children }) {
  const ref = useRef();

  useFrame(({camera}) => {
    ref.current.position.copy(camera.position.clone());
  })

  return (
  <group ref={ref}>
    {children}
  </group>)
}

function Model({ ...props }) {
  const [model, set] = useState()
  const [mixer, set2] = useState()
  const {camera,clock} = useThree();
  const texture = useLoader(THREE.TextureLoader, "concrete.jpg");

  useEffect(() => {
    void new GLTFLoader().load("./hand.glb", (gltf) => {
      gltf.scene.children[0].children[1].material = new THREE.MeshStandardMaterial({map: texture, color: 0x303030})
      if (gltf.animations.length) {
          set2(new THREE.AnimationMixer(gltf.scene));
      }
      set(gltf);
    });
    
    
  }, [])

  model?.animations.forEach(clip => {
      const action = mixer?.clipAction(clip);
      action?.startAt(props.offset);
      action?.play();
  });

  useFrame((state, delta) => {

    mixer?.update(delta);
    model?.scene.lookAt(camera.position);
    model?.scene.rotateY(Math.PI);
    model?.scene.rotateX(-Math.PI / 4 - Math.random());
    model?.scene.rotateZ(Math.random() / 4);
  })

  return model ? <primitive object={model.scene} {...props} /> : null
}

function BigModel({ ...props }) {
  const [model, set] = useState()
  const [mixer, set2] = useState()
  const {camera,clock} = useThree();
  const texture = useLoader(THREE.TextureLoader, "concrete.jpg");
  const [pos, setPos] = useState([Math.random() * 200 - 100, -30, Math.random() * 200 - 100]);

  useEffect(() => {
    void new GLTFLoader().load("./hand.glb", (gltf) => {
      gltf.scene.children[0].children[1].material = new THREE.MeshStandardMaterial({map: texture, color: 0x303030})
      if (gltf.animations.length) {
          set2(new THREE.AnimationMixer(gltf.scene));
      }
      set(gltf);
    });
    
    
  }, [])

  model?.animations.forEach(clip => {
      const action = mixer?.clipAction(clip);
      action?.startAt(props.offset);
      action?.play();
  });

  useFrame((state, delta) => {
    mixer?.update(delta);
    
    if(new THREE.Vector3(pos[0], pos[1], pos[2]).distanceTo(camera.position) > 200) {
      var vector = new THREE.Vector3( 0, 0, -1 );
      vector.applyQuaternion( camera.quaternion );

      setPos([camera.position.x + Math.random() * 200 - 100 + vector.x * 100,
        -120,
        camera.position.z + Math.random() * 200 - 100 + vector.z * 100]);
    }
    if(pos[1] < -30) {
      setPos([pos[0], pos[1] * (1-delta), pos[2]])
    }
  })

  return model ? <primitive object={model.scene} {...props} position={pos} /> : null
}

function Box({setId}) {
  const ref = useRef();
  const ref2 = useRef();
  const texture = useLoader(THREE.TextureLoader, "concrete.jpg");
  texture.wrapS = THREE.RepeatWrapping;
  texture.wrapT = THREE.RepeatWrapping;
  texture.repeat.set(3,3);
  const texture2 = useLoader(THREE.TextureLoader, "dark.png");
  texture2.wrapS = THREE.RepeatWrapping;
  texture2.wrapT = THREE.RepeatWrapping;
  texture2.repeat.set(3,3);

  let lastTime = 0;

  useFrame(({clock, camera}) => {
    ref.current.material.displacementScale = (Math.sin(clock.elapsedTime) - 1) * 2;
    ref.current.material.opacity = (Math.sin(clock.elapsedTime) + 2) / 2;
    ref2.current.material.displacementScale = (Math.sin(clock.elapsedTime) - 1) * 2;

    if(camera.position.distanceTo(new THREE.Vector3(0,0,0)) > 1000) {
      camera.position.y += 200 * (clock.elapsedTime - lastTime); 
    }

    if(camera.position.y > 1000) setId(0);
    lastTime = clock.elapsedTime;
  })

  return (<>
    <mesh ref={ref}>
      <boxGeometry args={[40,40,40, 100, 100, 100]} />
      <meshStandardMaterial displacementMap={texture2}  map={texture} side={THREE.DoubleSide} color={0x606060} transparent={true} opacity={1.0}/>
    </mesh>
    <mesh ref={ref2}>
      <boxGeometry args={[40,40,40, 100, 100, 100]} />
      <meshStandardMaterial map={texture2} side={THREE.DoubleSide} displacementMap={texture2} color={0x505050}/>
    </mesh>
    <mesh rotation={[Math.PI / 2, 0, 0]} position={[0,1000,0]}>
      <planeGeometry args={[10000,10000]} />
      <meshBasicMaterial color={0xffffff} fog={false}/>
    </mesh>
    </>)
}

function Tornado({ ...props}) {
  const ref = useRef();
  const [model, set] = useState()
  const {camera,clock} = useThree();
  const texture = useLoader(THREE.TextureLoader, "tornado.png");
  texture.wrapS = THREE.RepeatWrapping;
  texture.wrapT = THREE.RepeatWrapping;
  const [pos, setPos] = useState([Math.random() * 2000 - 1000, -10, Math.random() * 2000 - 1000]);

  useEffect(() => {
    void new GLTFLoader().load("./tornado.glb", (gltf) => {
      gltf.scene.children[0].material = new THREE.MeshStandardMaterial({map: texture, transparent: true, color: 0xffffff, side: THREE.DoubleSide})
      set(gltf);
    });
  }, [])


  useFrame((state, delta) => {
    if(ref.current)
    ref.current.rotation.y = clock.elapsedTime;
    texture.offset.set(clock.elapsedTime / 2, 0);

    if(new THREE.Vector3(pos[0], pos[1], pos[2]).distanceTo(camera.position) > 2000) {
      var vector = new THREE.Vector3( 0, 0, -1 );
      vector.applyQuaternion( camera.quaternion );

      setPos([camera.position.x + Math.random() * 200 - 100 + vector.x * 100,
        -120,
        camera.position.z + Math.random() * 200 - 100 + vector.z * 100]);
    }

    let newPos = camera.position.clone();
    newPos.y=0;
    if(new THREE.Vector3(pos[0], 0, pos[2]).distanceTo(newPos) < 10 ) {
      if(props.direction === "down")
        camera.position.y -= 10;
      else 
        camera.position.y += 300*delta;
    }
    if(pos[1] < -10) {
      setPos([pos[0], pos[1] * 0.99, pos[2]]);
    }
  })

  return model ? <primitive ref={ref} object={model.scene} {...props} position={pos} /> : null
}


let models = [];
for(let i=0; i < 30; i++)
{
  models[i] = i;
}


function App() {
  const [id, setId] = useState(0);
  const [characters, set] = useState([]);
  const radius = 20;
  var audio = new Audio('scream.wav');

  useEffect(() => {
    // doFetch(objkt)
    //   .then((data) => changeData(data, id))
    //   .then((char) => set(char));
  }, [id])


  return (
    <div id="wrapper" onMouseDown={() => {
      console.log("PRESSED");
      // audio.play();
    }}>
  <Canvas>
      <color attach="background" args={[0x050505]} />
      <ambientLight intensity = {0.1} />
      <Effect />
      
      <WasdControls />
      <LookControls />
      { id === 0 &&
      <>
      <fog attach="fog" args={[0x000000, 0, 100]} />
      <FollowCam> 
        <pointLight position={[0,0,0]} intensity={2.0} color={'green'}/>
      </FollowCam>
      <Suspense fallback={null}>
        <group name='intersectables'>
          <Stage />
          <Stairs count={500} radius={50} setId={setId}/>
        </group>
        <Particles count={200} radius={180}/>
      </Suspense>
      </>
      }

      { id === 1 &&
      <>
      <fog attach="fog" args={[0x000000, 0, 100]} />
      <FollowCam> 
        <pointLight position={[0,10,0]} intensity={2.0} color={'grey'}/>
      </FollowCam>
      <Suspense fallback={null}>
        {
          models.map((i) => { return <Model  position={[Math.sin(i) * Math.cos(i*10) * radius,
            Math.cos(i) * Math.cos(i*10) * radius,
            Math.sin(i*10) * radius]} offset={i/10} key={i}/>})
        }
        {
          models.map((i) => { return <BigModel
          rotation={[0, Math.random() * Math.PI * 2, 0]}
          offset={i/10} scale={[8,8,8]} key={i}/>})
        }
        
        <Box setId={setId}/>
      </Suspense>
      
      <group name='intersectables'>
          <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0,-21,0]}>
            <planeGeometry args={[10000,10000]} />
            <meshStandardMaterial color={0x101010} />
          </mesh>
        </group>
      </>
      }

      { id === 2 &&
      <>
      <FollowCam> 
        <pointLight position={[0,10,0]} intensity={2.0}/>
      </FollowCam>
      <group name='intersectables'>
          <Road count={1000} />
      </group>
      <Suspense fallback={null}>
        <Buildings count={2000} offset={{x: -1, y: -1}} setId={setId} />
        <Buildings count={2000} offset={{x: -1, y: 1}} setId={setId} />
        <Buildings count={2000} offset={{x: 1, y: -1}} setId={setId} />
        <Buildings count={2000} offset={{x: 1, y: 1}} setId={setId} />
        
      </Suspense>
      </>
      }
          {/* <FirstPersonControls lookSpeed={0.1} movementSpeed={10}/> */}
      {/* <OrbitControls />  */}
      <Stats />
  </Canvas>
  </div>
  );
}

export default App;
